import { render, staticRenderFns } from "./CollectionCreatorModal.vue?vue&type=template&id=53d2933c"
import script from "./CollectionCreatorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCreatorModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CollectionCreatorModal.vue?vue&type=style&index=0&id=53d2933c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports